(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusControllers')
        .controller('OwnerSendReminderModalController', Controller);

    Controller.$inject = ['$scope', 'esbEmployeeService'];

    function Controller($scope, esbEmployeeService) {

        $scope.ctrlCtxt = {
            searchTerm: '',
            availablePersons: [],
            selectedPersons: []
        };

        // Search Persons
        $scope.searchPersons = function () {
            $scope.ctrlCtxt.availablePersons = [];

            esbEmployeeService
                .searchEmployees($scope.ctrlCtxt.searchTerm)
                .then(function (foundPersons) {
                    $scope.ctrlCtxt.availablePersons = _.filter(foundPersons, function (person) {
                        return !person.DepartureDate;
                    });
                    $scope.ctrlCtxt.availablePersons =
                        _.differenceWith(
                            foundPersons,
                            $scope.ctrlCtxt.selectedPersons,
                            function (foundPerson, selectedPerson) {
                                return foundPerson.ItemPersonID === selectedPerson.ItemPersonID;
                            });
                });
        };

        // Select Person
        $scope.selectPerson = function (selectedPerson) {
            $scope.ctrlCtxt.selectedPersons.push(selectedPerson);
            _.remove($scope.ctrlCtxt.availablePersons, function (item) {
                return item.PSPEmployeeID === selectedPerson.PSPEmployeeID;
            });
        };

        // Unselect Person
        $scope.unSelectPerson = function (unSelectedPerson) {
            $scope.ctrlCtxt.availablePersons.push(unSelectedPerson);
            _.remove($scope.ctrlCtxt.selectedPersons, function (item) {
                return item.PSPEmployeeID === unSelectedPerson.PSPEmployeeID;
            });
        };
    }
})();